import { Tag } from '@/components/tag/tag'
import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

import { useHotelViewCounter } from '../hooks/useHotelViewCounter'

export const LocationViewCounter = () => {
	const { data: hotelInfo } = useHotelViewCounter()

	if (!hotelInfo) return null

	if (hotelInfo.viewCounter < 3) return null

	return (
		<div className={cn('hidden md:block')}>
			<Tag type="danger">
				<Typography style={'p'} element="span">
					{translate('location-view-count', [hotelInfo.viewCounter])}
				</Typography>
			</Tag>
		</div>
	)
}
